<template>
	<div class="navigation-buttons">
		<div v-for="item in filteredNavItems" :key="item.routeName">
			<div v-if="item.title === 'divider'" class="navigation-separator mx-2 my-2 max-w-[30px]" />
			<a :href="item.route" target="_blank" v-else-if="item.openInNewTab" class="nav-btn">
				<NavigationButton :item="item" />
			</a>
			<router-link v-else class="nav-btn" :to="{ name: item.routeName }">
				<NavigationButton :item="item" />
			</router-link>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import NavigationButton from './NavigationButton.vue';
import { hasAccountPermission } from '@/store/modules/account/getters';
import { isFeatureOn } from '@/store/modules/featureFlags/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { isNullOrUndefined } from '@/utils/helpers';
export default {
	name: 'NavigationButtonsList',
	components: { NavigationButton },
	props: {
		navItems: { type: Array },
	},
	computed: {
		...mapGetters(['user']),
		...mapGettersShorthand({ isFeatureOn, hasAccountPermission }),
		filteredNavItems() {
			return this.navItems.filter((item) => this.hasPermissionToViewItem(item) && this.isFeatureFlagOn(item));
		},
	},
	methods: {
		hasPermissionToViewItem(item) {
			const requiredAccountPermission = item.requiredAccountPermission;
			if (isNullOrUndefined(requiredAccountPermission)) {
				return true;
			}
			return this.hasAccountPermission(requiredAccountPermission);
		},
		isFeatureFlagOn(item) {
			const featureFlag = item.featureFlag;
			if (isNullOrUndefined(featureFlag)) {
				return true;
			}
			return this.isFeatureOn(featureFlag);
		},
	},
};
</script>

<style scoped lang="scss">
.navigation-buttons {
	$in-transition-time: 0.1s;
	$out-transition-time: 0.1s;

	.nav-btn {
		position: relative;
		display: flex;
		align-items: center;
		height: 30px;
		color: #4d4c52;
		border-radius: 7px;
		text-decoration: none;
		margin: 4px 8px;
		padding: 7px 5px;

		color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
		font-size: 13px;
		font-weight: 400;

		> * {
			z-index: 0;
		}
		.nav-button-icon {
			margin-right: 10px;
			width: 16px;
			height: 16px;
		}

		.nav-text {
			font-size: 14px;
			&.user-mode {
				font-size: 14px !important;
			}
		}
		&:hover {
			background: rgba(128, 128, 128, 0.1);
		}
		&:before {
			position: absolute;
			top: 0;
			left: 0;
			content: '';
			height: 100%;
			width: 100%;
			border-radius: 6px;
			background: rgba(255, 255, 255, 0.2);
			opacity: 0;
		}

		&.router-link-active {
			::v-deep {
				svg,
				path,
				rect,
				line {
					fill: black;
				}
			}
			color: #1b1c21;
			font-size: 13px;
			font-weight: 400;
			transition: $in-transition-time;
			background: #e7e8f9 !important;

			&:before {
				opacity: 1;
				transition: $in-transition-time;
			}
		}
		&:hover {
			background: #e7e8f980;
			&:before {
				transition: $in-transition-time;
				opacity: 0.7;
			}
		}
		&:not(:hover),
		:not(.router-link-active):not(:hover) {
			transition: $out-transition-time;

			&:before {
				transition: $out-transition-time;
			}
		}

		&:not(.router-link-active) {
			transition: $out-transition-time;
			::v-deep {
				svg,
				path,
				rect,
				line {
					fill: #6c7395;
				}
			}
		}
	}
}
.suffix-component-container {
	opacity: 0;
	transition: 0.2s;
}
.navigation-separator {
	border-bottom: 1px solid var(--border-color);
}
</style>
